import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { userPreferencesFavoriteSearchApi } from '@/main/api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';
import { savePredefinedSearch } from './index';
import { GetDomainPredefinedSearch } from './predefinedSearchTypes';


export function* getPredefinedSearchSaga(action: GetDomainPredefinedSearch) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      userPreferencesFavoriteSearchApi.getDomainUserPredefinedSearch,
      action.payload.routeUrl
    );

    if (response.data.result) {
      yield put(savePredefinedSearch(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        savePredefinedSearch(null, true, resultError.messagesDataError)
      );
    }
  }
}
